export default __webpack_public_path__ + "static/media/girl-playing.e101ae8a.jpg";